module.exports = __webpack_public_path__ + "img/9e23f1f.jpg";